import { FuseboxState } from "@shared/types";
import { PlayerService } from "./PlayerService";

export class FuseboxService {
    private readonly _playerService: PlayerService = new PlayerService();

    public async getState(): Promise<FuseboxState> {
        const data: FuseboxState = await fetch(`${VITE_API_URL}puzzle/fusebox/state`, {
            headers: {
                "X-PlayerSessionId": this._playerService.getPlayerSessionId(),
            },
        }).then(res => res.json() as Promise<FuseboxState>);
        return data;
    }

    public async toggleSwitch(switchIndex: number): Promise<FuseboxState> {
        return await fetch (`${VITE_API_URL}puzzle/fusebox/toggle`, {
            method: "post",
            headers: {
                "content-type": "application/json",
                "X-PlayerSessionId": this._playerService.getPlayerSessionId(),
            },
            body: JSON.stringify({
                switchIndex,
            }),
        }).then(res => res.json() as Promise<FuseboxState>);
    }
}
